'use client';

import { useEffect, useState } from 'react';

import { getUserId } from '~/lib/user-id';

export function UserIdDisplay(): React.JSX.Element {
  const [userId, setUserId] = useState<string>('');

  useEffect(() => {
    // Get the user ID on mount
    const id = getUserId();
    setUserId(id);
  }, []);

  if (!userId) {
    return <span className="text-xs text-muted-foreground">Loading ID...</span>;
  }

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-muted-foreground">User ID:</span>
      <code className="rounded bg-muted px-2 py-1 text-xs font-mono">
        {userId}
      </code>
    </div>
  );
}
